import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const AnimatedElement = ({ 
  children, 
  variant = 'slideUp',
  delay = 0,
  duration = 0.8 
}) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: false
  });

  const variants = {
    slideUp: {
      hidden: { opacity: 0, y: 30 },
      visible: { opacity: 1, y: 0 },
    },
    slideLeft: {
      hidden: { opacity: 0, x: -60 },
      visible: { opacity: 1, x: 0 },
    },
    scaleUp: {
      hidden: { opacity: 0, scale: 0.8 },
      visible: { opacity: 1, scale: 1 },
    },
     slideRight: { hidden: { opacity: 0, x: 40 }, visible: { opacity: 1, x: 0 } },
 
    fadeIn: { hidden: { opacity: 0 }, visible: { opacity: 1 } },
  };

  return (
    <motion.div
      ref={ref}
      variants={variants[variant]}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
     transition={{ duration: 0.8, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedElement;